import { Col, Row } from 'reactstrap';
import { Image, LI, P } from '../../../../AbstractElements';
import { useAppSelector } from '../../../../ReduxToolkit/Hooks';
import { dynamicImage } from '../../../../Service';
import ProfileBox from './ProfileBox';

const UserProfile = () => {
    const { user } = useAppSelector((state) => state.auth);   
    const roles = [
      "Admin", "Suppliers"
    ] 
    return (
        <LI className="profile-nav onhover-dropdown p-0">
            <div
                className="d-flex profile-media align-items-center"
                //  style={{flexDirection: "column"}}
            >
                <Row>
                    <Col>
                        <Image
                            className="b-r-10 img-40"
                            src={'https://gleads.vn/assets/common/logoBlack.svg'}
                            alt="user"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="flex-grow-1">
                            <span>{user.email}</span>
                            <P className="mb-0">{roles[Number(user.type) - 1]}</P>
                        </div>
                    </Col>
                </Row>
            </div>
            <ProfileBox />
        </LI>
    );
};

export default UserProfile;
